<template>
    <a
        :href="`/${option.url}`"
        class="sidebar__menu__group__option__url display--flex position--relative accessibility--pseudo accessibility--pseudo--default"
        :class="{ 'sidebar__menu__group__option__url--active': isActive }"
    >
        <component
            :is="option.icon"
        />
    </a>
</template>

<script>
export default {
    props: {
        option: Object,
        isActive: Boolean
    }
};
</script>